<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row>
        <el-form-item
          :label="$l('form_label_alternative_name') || '备选项名称'"
          prop="optionName"
        >
          <el-input
            clearable
            v-model="formData.optionName"
            :placeholder="
              $l('form_label_please_alternative_name') || '请输入备选项名称'
            "
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$l('form_label_alternative_english_name') || '备选项英文名称'"
          prop="optionNameEn"
        >
          <el-input
            clearable
            v-model="formData.optionNameEn"
            :placeholder="
              $l('form_label_please_alternative_english_name') ||
                '请输入备选项英文名称'
            "
          ></el-input>
        </el-form-item>
      </el-row>

      <!-- <el-row>
        <el-form-item
          :label="
            $l('form_label_alternative_full_display_text') ||
              '备选项完整显示文字'
          "
          prop="optionFullName"
        >
          <el-input
            clearable
            v-model="formData.optionFullName"
            :placeholder="
              $l('form_label_please_alternative_display_text') ||
                '请输入备选项完整显示文字'
            "
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="
            $l('form_label_alternative_full_display_text_english') ||
              '备选项完整显示文字英文'
          "
          prop="optionFullNameEn"
        >
          <el-input
            clearable
            v-model="formData.optionFullNameEn"
            :placeholder="
              $l('form_label_please_alternative_display_text_english') ||
                '请输入备选项完整显示文字英文'
            "
          ></el-input>
        </el-form-item>
      </el-row> -->

      <el-row :gutter="20">
        <el-col :span="24" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_valid_status') || '有效状态'"
            prop="optionStatus"
          >
            <el-radio-group :disabled="true" v-model="formData.optionStatus">
              <el-radio label="Y">{{
                $l('from_radio_effective') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('from_radio_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    optionCode: String,
    metadataType: String
  },
  components: {},
  data() {
    return {
      formData: {
        optionStatus: 'Y',
        metadataType: this.metadataType
      },
      rules: {
        optionName: [
          {
            required: true,
            message:
              this.$l('form_label_please_alternative_name') ||
              '请输入备选项名称',
            trigger: 'blur'
          }
        ],
        optionNameEn: [
          {
            required: true,
            message:
              this.$l('form_label_please_alternative_english_name') ||
              '请输入备选项英文名称',
            trigger: 'blur'
          }
        ],
        // optionFullName: [
        //   {
        //     required: true,
        //     message:
        //       this.$l("form_label_please_alternative_display_text") ||
        //       "请输入备选项完整显示文字",
        //     trigger: "blur",
        //   },
        // ],
        // optionFullNameEn: [
        //   {
        //     required: true,
        //     message:
        //       this.$l("form_label_please_alternative_display_text_english") ||
        //       "请输入备选项完整显示文字英文",
        //     trigger: "blur",
        //   },
        // ],
        optionStatus: [
          {
            required: true,
            message:
              this.$l('form_label_please_valid_status') || '请选择有效状态',
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.optionCode) return
      this.$api
        .materialOptionsDetailApi({
          optionCode: this.optionCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .materialOptionsSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
